import Box from "@mui/material/Box";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Link, useParams } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import person from "../../Components/assets/images/profilePicture.png";
import Payment from "./Payment";
import {
  GroupDetailWithParticipants,
  ExportPaymentAll,
  BaseUrl,
  getPaymentbyDate,
  GroupUserPayment,
} from "../../services/Url";
import ProfilePic from '../../Components/assets/images/profilePicture.png'
import { post } from "../../services/Service";

export default function GroupTabs() {
  const [value, setValue] = useState("1");
  const [pot, setPot] = useState([]);
  const [participant, setparticipant] = useState([]);
  const [file, setFile] = useState([]);
  const [exportPayment, setExportPayment] = useState(true);
  const [isloading, setIsloading] = useState(false)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const params = useParams();

  const singleDetail = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + GroupDetailWithParticipants + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        setPot(responseData.data.pot);
        setparticipant(responseData.data.participant);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    singleDetail();
  }, []);

  let matchedObjects = pot?.map((obj) => {
    let matchingObj = participant.find(
      (bbObj) => bbObj._id === obj.participants
    );
    if (matchingObj) {
      return { ...obj, ...matchingObj };
    } else {
      return null;
    }
  })
    .filter((obj) => obj !== null);


  const handler = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + ExportPaymentAll + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        const filename = responseData.message.split("/").pop();
        const link = document.createElement("a");
        link.href = "https://api-staging.pardnerpal.co.uk" + responseData.message;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setFile(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  };



  useEffect(() => {
    exportHandler();
  }, [value]);

  const exportHandler = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + GroupUserPayment + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        setExportPayment(responseData.data.payment);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box className="box-wrapper br-24">
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            className="tab_btns ptc_tab"
          >
            <Tab label="Participant" value="1" />
            <Tab label="Payment" value="2" />
            <Tab label="Export" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Box className="participant_list">
            {
              matchedObjects?.length > 0 ?
                matchedObjects?.map((item, i) => {
                  return (
                    <Link key={i} className="partItem_wpr" to={`/userdetail/${item._id}`}>
                      <Box className="participant_item" key={i}>
                        <Box className="participant_img">
                          <img
                            src={item?.profile_picture ? `https://api-staging.pardnerpal.co.uk/api/uploads/profile/${item?.profile_picture}` : ProfilePic}
                            alt="img"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginRight: "10px",
                              borderRadius: "50%",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center center",
                              backgroundSize: " cover",
                            }}
                          />
                        </Box>
                        <Box className="participant_ctnt">
                          <Typography className="fz-16 fw-bold">
                            {item?.first_name} {item?.last_name}
                          </Typography>
                          <Typography>
                            Pot Owner -{" "}
                            {item?.dateofbecomepotowner
                              ? moment(item.dateofbecomepotowner).format(
                                "YYYY-MM-DD"
                              )
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                    </Link>
                  );
                }) :
                <Typography className="fz-18 fw-bold text-center" >No Data Found</Typography>
            }
          </Box>
        </TabPanel>
        <TabPanel value="2">
          <Payment />
        </TabPanel>
        <TabPanel value="3">
          <Box className={exportPayment?.length > 0 ? "export_bx " : "export_bx justify-center"}>
            {
              exportPayment?.length > 0 ?
                <><Typography className="fz-18 fw-bold">Export Payment</Typography>
                  <Button className="btn-design" onClick={() => handler()}>
                    Download
                  </Button></> :
                <Typography className="fz-18 fw-bold" >No records found, Please try again later.</Typography>
            }
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
}

